import { render, staticRenderFns } from "./TemplateText.vue?vue&type=template&id=827ceb2a&"
import script from "./TemplateText.vue?vue&type=script&lang=js&"
export * from "./TemplateText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports